import { ConnectionMode } from './../../../../base/models/models.swagger.generated';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { startWith } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonGroupComponent } from '../../../../base/shared/button-group/button-group.component';
import { YesNoGroupButtonComponent } from '../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { NumericDirective } from '../../../../directives/numeric.directive';
import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';
import { ClientAdministrationEditFormGroup } from './client-administraion-edit-form.type';
import { PriceModelEditComponent } from './price-model-edit/price-model-edit.component';

@Component({
    selector: 'app-client-administraion-edit-form',
    templateUrl: './client-administraion-edit-form.component.html',
    styleUrls: ['./client-administraion-edit-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, NumericDirective, AccordionModule, YesNoGroupButtonComponent, ButtonGroupComponent, TranslateModule,
        PriceModelEditComponent
    ]
})
export class ClientAdministraionEditFormComponent implements OnInit {

  @Input() public clientEditForm: ClientAdministrationEditFormGroup;

  @ViewChild('priceModelDialog') public priceModelDialog: PriceModelEditComponent;

  public get isEdit(): boolean {
    return !!this.clientEditForm.get('id').value;
  }

  public ConnectionMode = ConnectionMode;

  constructor() { }

  public ngOnInit(): void {
    this.clientEditForm.get('automaticParkingSchedulesEnabled').valueChanges
      .pipe(
        startWith(this.clientEditForm.get('automaticParkingSchedulesEnabled').value)
      )
      .subscribe(val => {
        if (val) {
          this.clientEditForm.get('automaticParkingScheduleToleranceInMinutes').enable();
        } else {
          this.clientEditForm.get('automaticParkingScheduleToleranceInMinutes').disable();
        }
      });
  }

  public openPriceModelDialog(): void {
    this.priceModelDialog.openDialog(this.clientEditForm.controls.id.value);
  }
}
